import logo from "./logo.svg";
import Navibar from "./components/ui/Navibar";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Container from "react-bootstrap/Container";
import Footer from "./components/Footer";
import Spacer from "./components/ui/Spacer";
import Contactform from "./pages/Contactform";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function App() {
  return (
    <Router>
      <Navibar />
      <Spacer />
      <Switch>
        <Route path="/projects">
          <Projects />
        </Route>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/contact">
          <Contactform />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <Spacer />
      <Footer />
    </Router>
  );
}

export default App;
